// @ts-ignore
import * as Handlebars from 'handlebars/dist/handlebars';
import {
    AutocompleteComponent,
    CheckboxListFacetComponent,
    ColorFacetComponent,
    CustomContentComponent,
    DatePickerComponent,
    DateRangeFacetComponent,
    FacetWrapperComponent,
    FacetsListComponent,
    FeaturedItemsContentComponent,
    FeaturedItemsContentItemComponent,
    IconComponent,
    ImageContentComponent,
    LinkListFacetComponent,
    ModifiedQueryComponent,
    NumericRangeFacetComponent,
    PageSizeComponent,
    PaginationComponent,
    PopularQueriesComponent,
    QuerySuggestionsComponent,
    RangeSliderComponent,
    RangeSliderFacetComponent,
    RecentSearchesFacetComponent,
    RelatedSearchesFacetComponent,
    SearchComponent,
    SearchResultsComponent,
    SearchResultsItemComponent,
    SearchResultsListComponent,
    SearchWithinFacetComponent,
    SelectedFacetsComponent,
    SizeFacetComponent,
    SortingComponent,
    TabsComponent,
    TooltipComponent,
    ZoneComponent
} from './components';
import { HawksearchGlobal, HawksearchState, PageType } from './models';
import { searchService, trackingService } from './services';

declare let Hawksearch: HawksearchGlobal;

if (!Hawksearch) {
    Hawksearch = {} as HawksearchGlobal;
}

Hawksearch.service = searchService;
Hawksearch.handlebars = Handlebars.noConflict();

Hawksearch.handlebars.registerHelper('add', function (value1: number, value2: number): number {
    return value1 + value2;
});

Hawksearch.handlebars.registerHelper('and', function (...values: Array<any>): boolean {
    return values.slice(0, -1).every((v) => !!v); // Omit last argument as that is the Handlebars options function
});

Hawksearch.handlebars.registerHelper('attribute', function (attribute: string, condition: any): Handlebars.SafeString {
    return new Hawksearch.handlebars.SafeString(condition ? attribute : '');
});

Hawksearch.handlebars.registerHelper('concat', function (...values: Array<any>): string {
    if (values.length < 2) {
        return '';
    }

    return values.slice(0, -1).join(''); // Omit last argument as that is the Handlebars options function
});

Hawksearch.handlebars.registerHelper('eq', function (value1: any, value2: any): boolean {
    return value1 === value2;
});

Hawksearch.handlebars.registerHelper('exclude', function (options): any {
    return options.fn();
});

Hawksearch.handlebars.registerHelper('html', function (html: string): Handlebars.SafeString {
    return new Hawksearch.handlebars.SafeString(html);
});

Hawksearch.handlebars.registerHelper('if-else', function (condition: any, trueValue: any, falseValue: any): any {
    return condition ? trueValue : falseValue;
});

Hawksearch.handlebars.registerHelper('lt', function (value1: any, value2: any): boolean {
    return value1 < value2;
});

Hawksearch.handlebars.registerHelper('lte', function (value1: any, value2: any): boolean {
    return value1 <= value2;
});

Hawksearch.handlebars.registerHelper('gt', function (value1: any, value2: any): boolean {
    return value1 > value2;
});

Hawksearch.handlebars.registerHelper('gte', function (value1: any, value2: any): boolean {
    return value1 >= value2;
});

Hawksearch.handlebars.registerHelper('or', function (...values: Array<any>): boolean {
    return values.slice(0, -1).some((v) => !!v); // Omit last argument as that is the Handlebars options function
});

Hawksearch.handlebars.registerHelper('subtract', function (value1: number, value2: number): number {
    return value1 - value2;
});

customElements.define('hawksearch-autocomplete', AutocompleteComponent);
customElements.define('hawksearch-checkbox-list-facet', CheckboxListFacetComponent);
customElements.define('hawksearch-color-facet', ColorFacetComponent);
customElements.define('hawksearch-content-zone', ZoneComponent);
customElements.define('hawksearch-custom-content', CustomContentComponent);
customElements.define('hawksearch-date-picker', DatePickerComponent);
customElements.define('hawksearch-date-range-facet', DateRangeFacetComponent);
customElements.define('hawksearch-facet-wrapper', FacetWrapperComponent);
customElements.define('hawksearch-facets-list', FacetsListComponent);
customElements.define('hawksearch-featured-items-content', FeaturedItemsContentComponent);
customElements.define('hawksearch-featured-items-content-item', FeaturedItemsContentItemComponent);
customElements.define('hawksearch-icon', IconComponent);
customElements.define('hawksearch-image-content', ImageContentComponent);
customElements.define('hawksearch-link-list-facet', LinkListFacetComponent);
customElements.define('hawksearch-modified-query', ModifiedQueryComponent);
customElements.define('hawksearch-numeric-range-facet', NumericRangeFacetComponent);
customElements.define('hawksearch-page-size', PageSizeComponent);
customElements.define('hawksearch-pagination', PaginationComponent);
customElements.define('hawksearch-popular-queries', PopularQueriesComponent);
customElements.define('hawksearch-query-suggestions', QuerySuggestionsComponent);
customElements.define('hawksearch-range-slider', RangeSliderComponent);
customElements.define('hawksearch-range-slider-facet', RangeSliderFacetComponent);
customElements.define('hawksearch-recent-searches-facet', RecentSearchesFacetComponent);
customElements.define('hawksearch-related-searches-facet', RelatedSearchesFacetComponent);
customElements.define('hawksearch-results', SearchResultsComponent);
customElements.define('hawksearch-results-list', SearchResultsListComponent);
customElements.define('hawksearch-results-item', SearchResultsItemComponent);
customElements.define('hawksearch-search', SearchComponent);
customElements.define('hawksearch-search-within-facet', SearchWithinFacetComponent);
customElements.define('hawksearch-selected-facets', SelectedFacetsComponent);
customElements.define('hawksearch-size-facet', SizeFacetComponent);
customElements.define('hawksearch-sorting', SortingComponent);
customElements.define('hawksearch-tabs', TabsComponent);
customElements.define('hawksearch-tooltip', TooltipComponent);

addEventListener('popstate', (event) => {
    const state: HawksearchState = event.state;

    Hawksearch.searchRequest = state.searchRequest;
    Hawksearch.searchResponse = state.searchResponse;

    searchService.bindComponents(state.searchResponse);
});

dispatchEvent(new CustomEvent('hawksearch:initialized'));

trackingService.trackPageLoad(PageType.Custom);

const searchRequest = searchService.getRequestFromUrl();

searchService.search(searchRequest);
